import { connect } from 'react-redux';
import * as R from 'ramda';
import { getItem, setSelectedAffiliate } from '../../store/rackWaitTimesSlice';
import HistoryPanel from './HistoryPanel';

const mapState = R.applySpec({
  selectedAffiliate: getItem('selectedAffiliate'),
});

const mapDispatch = {
  setSelectedAffiliate,
};

export default connect(mapState, mapDispatch)(HistoryPanel);
